import {
  Component, ElementRef, EventEmitter,
  forwardRef, Inject, Injector,
  OnInit, ViewChild, Optional,
  NgModule,
  ViewEncapsulation
} from '@angular/core';

import { MdSelect, MdOption } from '@angular/material';

import { dataServiceFactory } from '../../services/data-service.provider';
import { OntimizeService } from '../../services';
import { OSharedModule } from '../../shared';
import { CommonModule } from '@angular/common';
import { InputConverter } from '../../decorators';
import { OFormComponent } from '../form/o-form.component';
import { OFormValue } from '../form/OFormValue';

import { OFormServiceComponent } from '../o-form-service-component.class';


export const DEFAULT_INPUTS_O_COMBO = [
  ...OFormServiceComponent.DEFAULT_INPUTS_O_FORM_SERVICE_COMPONENT,
  'translate',
  'nullSelection: null-selection'
];

export const DEFAULT_OUTPUTS_O_COMBO = [
  'onChange'
];


export class OComboComponent extends OFormServiceComponent implements OnInit {

  public static DEFAULT_INPUTS_O_COMBO = DEFAULT_INPUTS_O_COMBO;
  public static DEFAULT_OUTPUTS_O_COMBO = DEFAULT_OUTPUTS_O_COMBO;

  /* Inputs */
  @InputConverter()
  protected translate: boolean = false;
  @InputConverter()
  protected nullSelection: boolean = true;
  /* End inputs*/

  
  protected inputModel: ElementRef;

  
  protected selectModel: MdSelect;

  public onChange: EventEmitter<Object> = new EventEmitter<Object>();

  constructor(
      form: OFormComponent,
    elRef: ElementRef,
    injector: Injector) {
    super(form, elRef, injector);
    this.defaultValue = '';
  }

  ngOnInit() {
    this.initialize();
  }

  ensureOFormValue(value: any) {
    if (value instanceof OFormValue) {
      this.value = new OFormValue(value.value);
    } else if (value && !(value instanceof OFormValue)) {
      this.value = new OFormValue(value);
    } else if ((value === undefined || value === null) && this.nullSelection) {
      this.value = new OFormValue(undefined);
    } else {
      this.value = new OFormValue(this.defaultValue);
    }
    this.syncDataIndex();
  }

  ngOnDestroy() {
    this.destroy();
  }

  ngAfterViewInit(): void {
    if (this.queryOnInit) {
      this.queryData();
    } else if (this.queryOnBind) {
      //TODO do it better. When changing tabs it is necessary to invoke new query
      this.syncDataIndex();
    }
  }

  hasNullSelection(): boolean {
    return this.nullSelection;
  }

  syncDataIndex() {
    super.syncDataIndex();
    if (this._currentIndex !== undefined && this.nullSelection) {
      // first position is for null selection that it is not included into dataArray
      this._currentIndex += 1;
    }
  }

  getDescriptionValue() {
    let descTxt = '';
    if (this._currentIndex !== undefined && this.selectModel) {
      if (this.selectModel.selected) {
        descTxt = (this.selectModel.selected as any).viewValue;
      } else if (this.selectModel.options) {
        let option: MdOption = this.selectModel.options.toArray()[this._currentIndex];
        if (option) {
          option.select();
          descTxt = option.viewValue;
        }
      }

    }
    /*
    * Temporary code
    * I do not understand the reason why MdInput is not removing 'mat-empty' clase despite of the fact that
    * the input element of the description is binding value attribute
    */
    let placeHolderLbl = this.elRef.nativeElement.querySelectorAll('label.mat-input-placeholder');
    if (placeHolderLbl.length) {
      // Take only first, nested element does not matter.
      let element = placeHolderLbl[0];
      if (descTxt && descTxt.length > 0) {
        element.classList.remove('mat-empty');
      }
    }
    return descTxt;
  }

  getValue() {
    if (this.value instanceof OFormValue) {
      if (this.value.value !== undefined) {
        return this.value.value;
      } else if (this.value.value === undefined && this.nullSelection) {
        return null;
      }
    }
    if (this.nullSelection) {
      return null;
    }
    return '';
  }

  innerOnChange(event: any) {
    /*
    * It is neccessary to modify this.value to advice ngControl
    */
    if (event && event.length > 0 && this.dataArray && this.dataArray.length > 0) {
      //event is always a string...
      var self = this;
      this.dataArray.forEach((item, index) => {
        if (item.hasOwnProperty(self.valueColumn)) {
          let val = item[self.valueColumn];
          val = val ? val.toString() : '';
          if (val === event) {
            const value = this.parseByValueColumnType(val);
            self.setValueOnChange(value);
          }
        }
      });
    } else if (event === null && this.nullSelection) {
      this.setValueOnChange(undefined);
    } else if (typeof event === 'string' && event.length === 0 && this.nullSelection) {
      this.setValueOnChange(undefined);
    }
  }

  setValueOnChange(value: any) {
    this.ensureOFormValue(value);
    if (this._fControl && this._fControl.touched) {
      this._fControl.markAsDirty();
    }
    this.onChange.emit(value);
  }

  getOptionDescriptionValue(item: any = {}) {
    let descTxt = '';
    if (this.descriptionColArray && this.descriptionColArray.length > 0) {
      var self = this;
      this.descriptionColArray.forEach((col, index) => {
        let txt = item[col];
        if (txt) {
          if (self.translate && self.translateService) {
            txt = self.translateService.get(txt);
          }
          descTxt += txt;
        }
        if (index < self.descriptionColArray.length - 1) {
          descTxt += self.separator;
        }
      });
    }
    return descTxt;
  }

  getValueColumn(item: any) {
    if (item && item.hasOwnProperty(this.valueColumn)) {
      let option = item[this.valueColumn];
      if (option === 'undefined') {
        option = null;
      }
      return option;
    }
    return '';
  }

  isSelected(item: any, rowIndex: number): boolean {
    let selected = false;
    if (item && item.hasOwnProperty(this.valueColumn)
      && this.value) {
      let val = item[this.valueColumn];
      if (val === this.value.value) {
        selected = true;
        this._currentIndex = rowIndex;
      }
    }
    return selected;
  }

static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'o-combo',
  providers: [
    { provide: OntimizeService, useFactory: dataServiceFactory, deps: [Injector] }
  ],
  inputs: [
    ...DEFAULT_INPUTS_O_COMBO
  ],
  outputs: [
    ...DEFAULT_OUTPUTS_O_COMBO
  ],
  template: `
    <div [formGroup]="getFormGroup()" class="mat-combo-container custom-error" [mdTooltip]="tooltip" [mdTooltipPosition]="tooltipPosition"
        [mdTooltipShowDelay]="tooltipShowDelay">
        <md-select #selectModel [class.visible]="!isReadOnly" [class.hidden]="isReadOnly" class="mat-combo" [attr.id]="getAttribute()"
            [id]="getAttribute()" fxFill [formControlName]="getAttribute()" [placeholder]="placeHolder" [ngModel]="getValue()" (ngModelChange)="innerOnChange($event)">
            <md-option *ngIf="hasNullSelection()" value selected></md-option>
            <md-option *ngFor="let item of getDataArray(); let rowIndex = index" [value]="getValueColumn(item)">
                {{ getOptionDescriptionValue(item) }}
            </md-option>
        </md-select>
        <md-hint *ngIf="hasError('required')">
            <span>{{ 'FORM_VALIDATION.REQUIRED' | oTranslate }}</span>
        </md-hint>

        <md-form-field #innerInputContainer [class.visible]="isReadOnly" [class.hidden]="!isReadOnly" fxFlex fxFill>
            <input mdInput class="mat-input" type="text" [attr.id]="'fake_' + getAttribute()" [id]="'fake_' + getAttribute()" fxFill
                [class.ng-untouched]="getFormControl() && getFormControl().untouched" [class.ng-touched]="getFormControl() && getFormControl().touched"
                [class.ng-dirty]="getFormControl() && getFormControl().dirty" [class.ng-pristine]="getFormControl() && getFormControl().pristine"
                [class.ng-invalid]="getFormControl() && !getFormControl().valid" [class.ng-valid]="getFormControl() && getFormControl().valid"
                [placeholder]="placeHolder" [value]="getDescriptionValue()" [readonly]="isReadOnly" [disabled]="isDisabled">
            <md-hint *ngIf="hasError('required')">
                <span>{{ 'FORM_VALIDATION.REQUIRED' | oTranslate }}</span>
            </md-hint>
        </md-form-field>

    </div>
  `,
  styles: [`
    .hidden{display:none !important}.visible{display:inline-block}.mat-combo-container{position:relative}.mat-combo-container .mat-hint{display:block;position:absolute;font-size:75%;bottom:-1.5em}.mat-combo-container md-select.mat-combo{padding-top:0px}.mat-combo-container md-select.mat-combo .mat-select-trigger{margin:22px 0 0px 0px;height:24px}.mat-combo-container md-select.mat-combo .mat-select-trigger .mat-select-placeholder.mat-floating-placeholder{left:0px;top:-20px}.mat-combo-container md-select.mat-combo .mat-select-trigger .mat-select-value{top:0px;left:0px}.mat-combo-container md-select:focus:not(.mat-select-disabled) .mat-select-trigger{border-bottom-width:2px}.mat-tooltip{margin:0px !important}
  `],
  encapsulation: ViewEncapsulation.None
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: OFormComponent, decorators: [{ type: Optional }, { type: Inject, args: [forwardRef(() => OFormComponent), ] }, ]},
{type: ElementRef, },
{type: Injector, },
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'inputModel': [{ type: ViewChild, args: ['inputModel', ] },],
'selectModel': [{ type: ViewChild, args: ['selectModel', ] },],
};
}


export class OComboModule {
static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  declarations: [OComboComponent],
  imports: [OSharedModule, CommonModule],
  exports: [OComboComponent]
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
